// import "./Grid.css"

const alignValueMap =
{
  'top': 'start',
  'bottom': 'end',
  'center': 'center',
  'left': 'start',
  'right': 'end',
}
export const GridCell = ({ column, row, rowSpan, columnSpan, classNames, vertical, horizontal, children }) => {
  const css =
  {
    gridColumnStart: column ? column : '',
    gridColumnEnd: columnSpan ? `span ${columnSpan}` : 'auto',
    gridRowStart: row ? row : '',
    gridRowEnd: rowSpan ? `span ${rowSpan}` : '',
    alignSelf: vertical ? alignValueMap[vertical] : 'initial',
    justifySelf: horizontal ? alignValueMap[horizontal] : 'initial',
  };
  return (
    <div style={css} className={['ui-grid-cell', ...(classNames ?? [])].join(' ')}>
      {
        children
      }
    </div>
  );
}


export const Grid = ({ columns, classNames, rowGap, columnGap, children }) => {
  const css =
  {
    gridTemplateColumns: ' 1fr'.repeat(columns ?? 1),
    rowGap: rowGap ? `${rowGap}rem` : '',
    columnGap: columnGap ? `${columnGap}rem` : '',
  };
  return (
    <div style={css}
      className={[
        'ui-grid',
        'grid',
        'gap-y-4',
        'gap-x-8',
        ...(classNames ?? []),
      ].join(' ')}
    >
      {
        children
      }
    </div>
  );
}
